import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

const createWalletTransactionSchema = z.object({
  accountId: z.string().min(1),
  type: z.enum(["BONUS", "REWARD", "WITHDRAWAL", "MANUAL"]),
  amount: z.number(),
  balanceBefore: z.number(),
  balanceAfter: z.number(),
  reference: z.string().optional(),
  paymentId: z.string().optional().nullable(),
  bonusId: z.string().optional().nullable(),
  withdrawalId: z.string().optional().nullable(),
});

export class CreateWalletTransactionDto extends createZodDto(createWalletTransactionSchema) {}
